<!--v-if="sport === 'Football'"-->
<template>
    <div>
        <div v-if="sport === 'Football'">
            <soccer :connection="connection" :eventId="eventId"></soccer>
        </div>
        <div v-if="sport === 'Tennis'">
            <tennis :connection="connection" :eventId="eventId"></tennis>
        </div>
    </div>
</template>

<script>
    import Soccer from './scoreboard/Soccer.vue';
    import Tennis from './scoreboard/Tennis.vue';
    import { HubConnection } from "@aspnet/signalr";
    export default {
        name: 'Scoreboard',
        components: {
            Soccer,
            Tennis
        },
        props: {
            sport: String,
            eventId: String,
            connection: HubConnection,
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
